module.exports = __webpack_public_path__ + "static/media/sortedDown.5f7a1076.png";